import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    position: fixed;
    top: 80px;
    display: flex;
    padding-left: 96px;
    height: 48px;
    margin: 0;
    background: ${theme.colors.white};
    margin-bottom: 40px;
    z-index: 2;
  `}
`

export const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;

    > a {
      font-family: ${theme.font.montserrat};
      font-size: ${theme.font.sizes.normal};
      font-weight: ${theme.font.normal};
      color: ${theme.colors.darkGray};
      margin-right: 14px;
      text-decoration: none;
      transition: color ${theme.transition.default};

      > svg {
        width: 14px;
        height: 11px;
        margin-right: 14px;

        path {
          fill: ${theme.colors.darkGray};
        }
      }

      &:hover {
        color: ${theme.colors.primary};

        > svg path {
          fill: ${theme.colors.primary};
        }
      }
    }

    > h4 {
      font-family: ${theme.font.montserrat};
      font-size: ${theme.font.sizes.normal};
      font-weight: ${theme.font.normal};
      color: ${theme.colors.darkGray};
      margin-right: 14px;

      > b {
        font-family: ${theme.font.montserrat};
        font-size: ${theme.font.sizes.normal};
        font-weight: ${theme.font.xbold};
        color: ${theme.colors.darkGray};
      }
    }

    > span {
      margin: 0 24px;
    }

    ${media.lessThan('medium')`
      > a {
        margin-right: 0px;

        > svg {
          width: 6px;
        }
      }

      > h4 {
        margin-right: 0;
      }

      > span {
        margin: 0 8px;
      }
    `}

    ${media.lessThan('small')`
      > h4 {
        display: none;
      }

      > span {
        display: none;
      }
    `}
  `}
`
